{
  "version": "0.1.38",
  "packageName": "@classic-homes/theme-svelte",
  "importPath": "@classic-homes/theme-svelte",
  "generatedFrom": "packages/svelte/src/lib/schemas/index.ts",
  "summary": {
    "totalExports": 72,
    "valueExports": 56,
    "typeExports": 16
  },
  "sections": {
    "zod": {
      "reexports": [
        {
          "name": "z",
          "description": "Re-export of Zod from @classic-homes/theme-svelte",
          "importPath": "@classic-homes/theme-svelte"
        }
      ]
    },
    "auth": {
      "fieldValidators": [
        {
          "name": "emailSchema",
          "description": "Email validation",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "fullNameSchema",
          "description": "Full name validation",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "loginPasswordSchema",
          "description": "Simpler password validation for login",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "mfaCodeSchema",
          "description": "MFA code validation (6 digits)",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "passwordSchema",
          "description": "Strong password (8+ chars, mixed case, numbers, special)",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "phoneSchema",
          "description": "Phone number validation",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "totpSecretSchema",
          "description": "TOTP secret validation (Base32 encoded)",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "usernameSchema",
          "description": "Username validation (3-30 chars, alphanumeric)",
          "importPath": "@classic-homes/theme-svelte"
        }
      ],
      "formSchemas": [
        {
          "name": "changePasswordSchema",
          "description": "Change password form schema",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "emailChangeSchema",
          "description": "Email change form schema with password confirmation",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "forgotPasswordSchema",
          "description": "Forgot password form schema",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "loginSchema",
          "description": "Complete login form schema",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "mfaSetupSchema",
          "description": "MFA setup form schema (code verification during setup)",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "mfaVerifySchema",
          "description": "MFA verification form schema (code + optional trust device)",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "profileUpdateSchema",
          "description": "Profile update form schema (firstName, lastName, email, phone)",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "registerSchema",
          "description": "Complete registration form schema",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "resetPasswordSchema",
          "description": "Reset password form schema",
          "importPath": "@classic-homes/theme-svelte"
        }
      ],
      "apiSchemas": [
        {
          "name": "authTokensSchema",
          "description": "Auth tokens validation (accessToken, refreshToken)",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "loginResponseSchema",
          "description": "Login API response validation schema",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "userSchema",
          "description": "User object validation schema",
          "importPath": "@classic-homes/theme-svelte"
        }
      ],
      "types": [
        {
          "name": "AuthTokens",
          "description": "Auth Tokens type export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "ChangePasswordFormData",
          "description": "Change Password Form Data type export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "EmailChangeFormData",
          "description": "Email Change Form Data type export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "ForgotPasswordFormData",
          "description": "Forgot Password Form Data type export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "LoginFormData",
          "description": "Login Form Data type export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "LoginResponse",
          "description": "Login Response type export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "MfaSetupFormData",
          "description": "Mfa Setup Form Data type export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "MfaVerifyFormData",
          "description": "Mfa Verify Form Data type export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "ProfileUpdateFormData",
          "description": "Profile Update Form Data type export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "RegisterFormData",
          "description": "Register Form Data type export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "ResetPasswordFormData",
          "description": "Reset Password Form Data type export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "User",
          "description": "User type export",
          "importPath": "@classic-homes/theme-svelte"
        }
      ]
    },
    "common": {
      "stringValidators": [
        {
          "name": "nonEmptyString",
          "description": "Non-empty string validation",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "optionalString",
          "description": "Optional String utility export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "optionalUrlSchema",
          "description": "Optional Url Schema validation schema",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "slugSchema",
          "description": "URL slug validation",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "trimmedString",
          "description": "Trimmed string",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "urlSchema",
          "description": "URL validation",
          "importPath": "@classic-homes/theme-svelte"
        }
      ],
      "numberValidators": [
        {
          "name": "nonNegativeInt",
          "description": "Non-negative integer",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "numericString",
          "description": "Numeric String utility export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "percentageSchema",
          "description": "Percentage (0-100)",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "positiveInt",
          "description": "Positive integer validation",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "priceSchema",
          "description": "Price validation",
          "importPath": "@classic-homes/theme-svelte"
        }
      ],
      "dateValidators": [
        {
          "name": "dateStringSchema",
          "description": "Date String Schema validation schema",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "futureDateSchema",
          "description": "Future date validation",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "isoDateSchema",
          "description": "ISO date string validation",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "pastDateSchema",
          "description": "Past date validation",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "timeStringSchema",
          "description": "Time String Schema validation schema",
          "importPath": "@classic-homes/theme-svelte"
        }
      ],
      "arrayValidators": [
        {
          "name": "maxLengthArray",
          "description": "Max Length Array utility export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "nonEmptyArray",
          "description": "Non Empty Array utility export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "uniqueArray",
          "description": "Unique Array utility export",
          "importPath": "@classic-homes/theme-svelte"
        }
      ],
      "objectValidators": [
        {
          "name": "idSchema",
          "description": "Id Schema validation schema",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "paginationSchema",
          "description": "Pagination Schema validation schema",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "searchParamsSchema",
          "description": "Search Params Schema validation schema",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "uuidSchema",
          "description": "Uuid Schema validation schema",
          "importPath": "@classic-homes/theme-svelte"
        }
      ],
      "fileValidators": [
        {
          "name": "allowedFileTypes",
          "description": "File type validation",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "imageFileSchema",
          "description": "Image file validation",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "maxFileSize",
          "description": "File size limit validation",
          "importPath": "@classic-homes/theme-svelte"
        }
      ],
      "contactValidators": [
        {
          "name": "addressSchema",
          "description": "Address Schema validation schema",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "phoneNumberSchema",
          "description": "Phone Number Schema validation schema",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "postalCodeSchema",
          "description": "Postal Code Schema validation schema",
          "importPath": "@classic-homes/theme-svelte"
        }
      ],
      "apiSchemas": [
        {
          "name": "apiResponseSchema",
          "description": "Standard API response schema",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "paginatedResponseSchema",
          "description": "Paginated API response",
          "importPath": "@classic-homes/theme-svelte"
        }
      ],
      "utilityFunctions": [
        {
          "name": "makePartial",
          "description": "Make Partial utility export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "omitKeys",
          "description": "Omit Keys utility export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "pickKeys",
          "description": "Pick Keys utility export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "withMessage",
          "description": "With Message utility export",
          "importPath": "@classic-homes/theme-svelte"
        }
      ],
      "types": [
        {
          "name": "Address",
          "description": "Address type export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "PaginatedResponse",
          "description": "Paginated Response type export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "PaginationParams",
          "description": "Pagination Params type export",
          "importPath": "@classic-homes/theme-svelte"
        },
        {
          "name": "SearchParams",
          "description": "Search Params type export",
          "importPath": "@classic-homes/theme-svelte"
        }
      ]
    }
  },
  "all": [
    {
      "name": "Address",
      "description": "Address type export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "addressSchema",
      "description": "Address Schema validation schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "allowedFileTypes",
      "description": "File type validation",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "apiResponseSchema",
      "description": "Standard API response schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "AuthTokens",
      "description": "Auth Tokens type export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "authTokensSchema",
      "description": "Auth tokens validation (accessToken, refreshToken)",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "ChangePasswordFormData",
      "description": "Change Password Form Data type export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "changePasswordSchema",
      "description": "Change password form schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "dateStringSchema",
      "description": "Date String Schema validation schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "EmailChangeFormData",
      "description": "Email Change Form Data type export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "emailChangeSchema",
      "description": "Email change form schema with password confirmation",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "emailSchema",
      "description": "Email validation",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "ForgotPasswordFormData",
      "description": "Forgot Password Form Data type export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "forgotPasswordSchema",
      "description": "Forgot password form schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "fullNameSchema",
      "description": "Full name validation",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "futureDateSchema",
      "description": "Future date validation",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "idSchema",
      "description": "Id Schema validation schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "imageFileSchema",
      "description": "Image file validation",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "isoDateSchema",
      "description": "ISO date string validation",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "LoginFormData",
      "description": "Login Form Data type export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "loginPasswordSchema",
      "description": "Simpler password validation for login",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "LoginResponse",
      "description": "Login Response type export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "loginResponseSchema",
      "description": "Login API response validation schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "loginSchema",
      "description": "Complete login form schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "makePartial",
      "description": "Make Partial utility export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "maxFileSize",
      "description": "File size limit validation",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "maxLengthArray",
      "description": "Max Length Array utility export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "mfaCodeSchema",
      "description": "MFA code validation (6 digits)",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "MfaSetupFormData",
      "description": "Mfa Setup Form Data type export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "mfaSetupSchema",
      "description": "MFA setup form schema (code verification during setup)",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "MfaVerifyFormData",
      "description": "Mfa Verify Form Data type export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "mfaVerifySchema",
      "description": "MFA verification form schema (code + optional trust device)",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "nonEmptyArray",
      "description": "Non Empty Array utility export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "nonEmptyString",
      "description": "Non-empty string validation",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "nonNegativeInt",
      "description": "Non-negative integer",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "numericString",
      "description": "Numeric String utility export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "omitKeys",
      "description": "Omit Keys utility export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "optionalString",
      "description": "Optional String utility export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "optionalUrlSchema",
      "description": "Optional Url Schema validation schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "PaginatedResponse",
      "description": "Paginated Response type export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "paginatedResponseSchema",
      "description": "Paginated API response",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "PaginationParams",
      "description": "Pagination Params type export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "paginationSchema",
      "description": "Pagination Schema validation schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "passwordSchema",
      "description": "Strong password (8+ chars, mixed case, numbers, special)",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "pastDateSchema",
      "description": "Past date validation",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "percentageSchema",
      "description": "Percentage (0-100)",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "phoneNumberSchema",
      "description": "Phone Number Schema validation schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "phoneSchema",
      "description": "Phone number validation",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "pickKeys",
      "description": "Pick Keys utility export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "positiveInt",
      "description": "Positive integer validation",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "postalCodeSchema",
      "description": "Postal Code Schema validation schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "priceSchema",
      "description": "Price validation",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "ProfileUpdateFormData",
      "description": "Profile Update Form Data type export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "profileUpdateSchema",
      "description": "Profile update form schema (firstName, lastName, email, phone)",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "RegisterFormData",
      "description": "Register Form Data type export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "registerSchema",
      "description": "Complete registration form schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "ResetPasswordFormData",
      "description": "Reset Password Form Data type export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "resetPasswordSchema",
      "description": "Reset password form schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "SearchParams",
      "description": "Search Params type export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "searchParamsSchema",
      "description": "Search Params Schema validation schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "slugSchema",
      "description": "URL slug validation",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "timeStringSchema",
      "description": "Time String Schema validation schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "totpSecretSchema",
      "description": "TOTP secret validation (Base32 encoded)",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "trimmedString",
      "description": "Trimmed string",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "uniqueArray",
      "description": "Unique Array utility export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "urlSchema",
      "description": "URL validation",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "User",
      "description": "User type export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "usernameSchema",
      "description": "Username validation (3-30 chars, alphanumeric)",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "userSchema",
      "description": "User object validation schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "uuidSchema",
      "description": "Uuid Schema validation schema",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "withMessage",
      "description": "With Message utility export",
      "importPath": "@classic-homes/theme-svelte"
    },
    {
      "name": "z",
      "description": "Re-export of Zod from @classic-homes/theme-svelte",
      "importPath": "@classic-homes/theme-svelte"
    }
  ]
}